<section
  class="zp:font-mont zp:relative zp:min-h-screen zp:overflow-scroll zp:flex zp:items-center zp:justify-center"
>
  @if (state.isInitialized) {
    <div class="zp:relative zp:w-full zp:lg:w-166.5">
      @if (!state.completed) {
        <button
          class="zp:hidden zp:lg:block zp:size-10 zp:bg-white zp:p-2 zp:absolute zp:-right-3 zp:-top-3 zp:rounded-full zp:cursor-pointer zp:z-50 zp:shadow-md zp:hover:shadow-lg"
          (click)="closePopup()"
        >
          <span class="text-base">×</span>
        </button>
      }
      <div
        class="zp:bg-white zp:max-w-full zp:md:max-w-166.5 zp:relative zp:rounded! zp:overflow-hidden! zp:mx-auto zp:animate-fade-in"
      >
        <!--  -->
        <!--
        Things to consider
        1. Have to use the payment channel name to show the main content not the id, since the list of channels can change.
        2. Want to remove the sidebar panel when the currency is not naira and display the card content.
        3. What channels are selected for every new account?
        -->
        @if (!state.completed) {
          <ng-template #paymentHeader>
            <div
              class="zp:grid zp:grid-cols-4 zp:place-items-center zp:border-b zp:border-b-ZTN-200 zp:pb-3 zp:px-4 zp:pt-4 zp:md:px-0"
            >
              <div class="zp:col-span-1 zp:justify-self-start">
                <img src="assets/img/zest.svg" alt="logo" />
              </div>
              <div class="zp:col-span-3 zp:justify-self-end">
                <div class="">
                  <p
                    class="zp:text-end zp:font-bold zp:text-lg zp:md:text-2xl zp:-tracking-tighter-[2%]"
                  >
                    <span class="zp:text-xs zp:md:text-sm">{{
                      transactionData?.currency
                    }}</span>
                    {{ amount ? (amount | currency: " ") : "" }}
                  </p>
                  <span
                    class="zp:block zp:text-xs zp:text-ZTN-700 zp:font-medium zp:py-0.5"
                    >Amount: {{ subtotal ? (subtotal | currency: " ") : 0 }} |
                    Fee:
                    {{ transactionData?.currency }}
                    {{ fee ? (fee | currency: " ") : 0 }}</span
                  >
                  <p class="zp:block zp:text-ZTN-500 zp:text-sm zp:text-right">
                    {{ transactionData?.email }}
                  </p>
                </div>
              </div>
            </div>
          </ng-template>

          @if (isMobile) {
            <div class="zp:block zp:md:hidden">
              @if (!isProd) {
                <div
                  class="zp:bg-ZTO-50 zp:py-2 zp:px-3 zp:border-b zp:border-b-2 zp:border-b-ZTO-500 zp:flex zp:justify-center zp:items-center zp:gap-x-2.5"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_6140_4018)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 -3.85639e-07 8 0C3.5888 3.85639e-07 -3.85639e-07 3.5888 0 8C3.85639e-07 12.4112 3.5888 16 8 16ZM8.8 11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8C7.2 7.55817 7.55817 7.2 8 7.2C8.44183 7.2 8.8 7.55817 8.8 8V11.2ZM8 4C7.55817 4 7.2 4.35817 7.2 4.8C7.2 5.24183 7.55817 5.6 8 5.6C8.44183 5.6 8.8 5.24183 8.8 4.8C8.8 4.35817 8.44183 4 8 4Z"
                        fill="#F79009"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6140_4018">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <p class="zp:text-xs zp:text-ZTN-900">
                    This transaction is in Test mode
                  </p>
                </div>
              }
              @if (selectedChannelName && mobileView === "payment") {
                <div
                  class="zp:bg-ZTN-100 zp:px-4 zp:py-3 zp:flex zp:justify-between zp:items-center"
                >
                  <div
                    class="zp:flex zp:justify-between zp:items-center zp:gap-x-1"
                  >
                    <div
                      class="zp:rounded-full zp:flex zp:justify-center zp:items-center zp:size-6 zp:bg-white"
                    >
                      @if (currency === "USD") {
                        <svg-icon
                          [name]="appService.modifyPaymentTokenName('card')"
                          svgClass="img-fluid w-3"
                          class="zp:fill-ZTN-900 zp:stroke-ZTN-900 zp:stroke-0"
                        ></svg-icon>
                      } @else {
                        <svg-icon
                          [name]="
                            appService.modifyPaymentTokenName(
                              selectedChannelName
                            )
                          "
                          svgClass="img-fluid w-3"
                          class="zp:fill-ZTN-900 zp:stroke-ZTN-900 zp:stroke-0"
                        ></svg-icon>
                      }
                    </div>
                    @if (currency === "USD") {
                      <p class="zp:text-xs zp:ZTN-900">
                        {{ "Card" }}
                      </p>
                    } @else {
                      <p class="zp:text-xs zp:ZTN-900">
                        {{ selectedChannelName }}
                      </p>
                    }
                  </div>
                  <p
                    class="zp:cursor-pointer zp:font-semibold zp:text-xs"
                    (click)="closePopup()"
                  >
                    Cancel
                  </p>
                </div>
              }

              <ng-container *ngTemplateOutlet="paymentHeader"></ng-container>
            </div>
          }

          <div
            class="zp:md:grid zp:block zp:md:grid-cols-15 zp:rounded zp:md:h-[620px]"
            [class.zp:h-[calc(100dvh-159px)]]="
              isMobile && mobileView === 'payment' && !isProd
            "
            [class.zp:h-[calc(100dvh-125px)]]="
              isMobile && mobileView === 'payment' && !isProd
            "
            [class.zp:h-[calc(100dvh-111px)]]="
              isMobile && mobileView === 'channel' && !isProd
            "
            [class.zp:h-[calc(100dvh-77px)]]="
              isMobile && mobileView === 'channel' && isProd
            "
          >
            <!-- SIDEPANEL -->
            <aside
              class="zp:bg-ZTN-100 zp:md:col-span-5 zp:h-full zp:flex zp:flex-col zp:min-h-0"
              [class.zp:hidden]="isMobile && mobileView === 'payment'"
              [class.zp:block]="isMobile && mobileView === 'channel'"
            >
              <p
                class="zp:hidden zp:md:block zp:text-ZTN-900 zp:font-bold zp:text-xs zp:px-8 zp:pt-10 zp:pb-8 zp:shrink-0"
              >
                PAY WITH
              </p>
              <p
                class="zp:block zp:md:hidden zp:text-ZTN-900 zp:font-semibold zp:text-base zp:px-8 zp:pt-8 zp:pb-6 zp:shrink-0"
              >
                Payment Methods
              </p>
              <nav
                #paymentChannelsList
                (scroll)="onPaymentChannelsScroll()"
                class="zp:text-sm zp:px-8 zp:flex-1 zp:min-h-0 zp:overflow-y-auto scrollbar-hide"
              >
                @if (channels && channels.length > 0 && checkCurrency()) {
                  @for (channel of channels; track channel) {
                    <div
                      class="zp:mb-6 zp:cursor-pointer zp:flex zp:items-center"
                      (click)="selectChannel(channel)"
                    >
                      <div
                        class="zp:rounded-full zp:flex zp:justify-center zp:items-center zp:size-10"
                        [ngClass]="{
                          'zp:bg-ZTG-50 zp:border zp:border-ZTG-500':
                            channel.isActive,
                          'zp:bg-white': !channel.isActive,
                        }"
                      >
                        <svg-icon
                          [name]="
                            appService.modifyPaymentTokenName(
                              channel.channelName
                            )
                          "
                          svgClass="img-fluid w-30"
                          class="zp:fill-ZTN-900"
                          [ngClass]="{
                            'zp:stroke-ZTG-BC': channel.isActive,
                            'zp:stroke-ZTN-900 zp:stroke-0': !channel.isActive,
                          }"
                        ></svg-icon>
                      </div>
                      <p
                        class="zp:pl-3 payment-token zp:text-sm"
                        [ngClass]="{
                          'zp:text-ZTG-500 zp:font-bold': channel.isActive,
                          'zp:text-ZTN-900': !channel.isActive,
                        }"
                      >
                        {{
                          appService.modifyPaymentTokenName(channel.channelName)
                        }}
                      </p>
                    </div>
                  }
                } @else {
                  <div
                    class="zp:mb-6 zp:cursor-pointer zp:flex zp:items-center"
                  >
                    <div
                      class="zp:rounded-full zp:bg-ZTG-50 zp:border zp:border-ZTG-500 zp:flex zp:justify-center zp:items-center zp:size-10"
                    >
                      <svg-icon
                        [name]="appService.modifyPaymentTokenName('card')"
                        svgClass="img-fluid w-30"
                        class="zp:fill-ZTN-900 zp:stroke-ZTG-BC"
                      ></svg-icon>
                    </div>
                    <p class="zp:pl-3 zp:text-sm">Card</p>
                  </div>
                }
              </nav>
              @if (showChannelsScrollArrow) {
                <div class="zp:flex zp:justify-center zp:pt-1 zp:shrink-0">
                  <button
                    type="button"
                    aria-label="Scroll to more payment methods"
                    class="payment-channels-scroll-btn zp:cursor-pointer zp:bg-white zp:rounded-full zp:size-9 zp:flex zp:items-center zp:justify-center zp:shadow-md zp:border zp:border-ZTN-300"
                    (click)="scrollPaymentChannelsDown()"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 8L10 12L14 8"
                        stroke="#4A1FB8"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              }
              @if (!state.completed) {
                <div
                  class="zp:md:hidden zp:mt-17 zp:flex zp:justify-center zp:items-center zp:shrink-0"
                >
                  <button
                    class="zp:border zp:border-ZTN-300 zp:text-xs zp:rounded-2xl zp:py-2 zp:px-3 zp:bg-ZTN-50 zp:cursor-pointer"
                    (click)="closePopup()"
                  >
                    Cancel Payment
                  </button>
                </div>
              }
            </aside>
            <!-- MAIN CONTENT -->
            <main
              class="zp:md:col-span-10 zp:grid zp:grid-rows-10 zp:md:grid-rows-12 zp:md:h-[620px] zp:bg-white"
              [class.zp:hidden]="isMobile && mobileView === 'channel'"
              [class.zp:h-[calc(100dvh-125px)]]="
                isMobile && mobileView === 'payment'
              "
            >
              @if (!isMobile) {
                @if (!isProd) {
                  <div
                    class="zp:bg-ZTO-50 zp:py-2 zp:px-3 zp:border-b zp:border-b-2 zp:border-b-ZTO-500 zp:flex zp:justify-center zp:items-center zp:gap-x-2.5"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_6140_4018)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 -3.85639e-07 8 0C3.5888 3.85639e-07 -3.85639e-07 3.5888 0 8C3.85639e-07 12.4112 3.5888 16 8 16ZM8.8 11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8C7.2 7.55817 7.55817 7.2 8 7.2C8.44183 7.2 8.8 7.55817 8.8 8V11.2ZM8 4C7.55817 4 7.2 4.35817 7.2 4.8C7.2 5.24183 7.55817 5.6 8 5.6C8.44183 5.6 8.8 5.24183 8.8 4.8C8.8 4.35817 8.44183 4 8 4Z"
                          fill="#F79009"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6140_4018">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <p class="zp:text-xs zp:text-ZTN-900">
                      This transaction is in Test mode
                    </p>
                  </div>
                }
                <header class="zp:row-span-2 zp:self-end zp:px-4 zp:md:px-8">
                  <ng-container
                    *ngTemplateOutlet="paymentHeader"
                  ></ng-container>
                </header>
              }

              <section
                class="zp:row-span-9 zp:md:row-span-9 zp:overflow-auto scrollbar-hide zp:px-4 zp:md:px-8"
              >
                @if (hasVisitedChannel("card")) {
                  <div
                    class="zp:my-12 zp:h-[calc(100%_-_6rem)]"
                    aria-labelledby="card-tab"
                    [class.zp:hidden]="!checkChannels('card')"
                  >
                    <card-channel
                      [activeTab]="activePaymentTab"
                      (onRedirect)="onRedirect()"
                      (onComplete)="paymentCompleted($event)"
                      (onFeeChange)="onCardFeeChange($event)"
                    ></card-channel>
                  </div>
                }
                @if (hasVisitedChannel("transfer")) {
                  <div
                    class="tab-pane fade zp:my-12"
                    id="transfer"
                    role="tabpanel"
                    aria-labelledby="accounts-tab"
                    [class.zp:hidden]="!checkChannels('transfer')"
                  >
                    <div class="d-flex flex-column justify-content-between">
                      <ng-container>
                        <div class="managedaccount">
                          <!-- <ul
                          class="nav nav-tabs managedaccount__channel-type"
                          id="accountsTab"
                          role="tablist"
                          >
                          <li class="nav-item" role="presentation">
                            <! <button class="nav-link active" id="transfer-tab" data-bs-toggle="tab" data-bs-target="#transfer" type="button" role="tab" aria-controls="transfer" aria-selected="true">
                            <button
                              class="managedaccount__channel nav-link active"
                              id="transfer-tab"
                              data-channel="account"
                              data-bs-toggle="tab"
                              data-bs-target="#transfer"
                              type="button"
                              role="tab"
                              aria-controls="transfer"
                              aria-selected="true"
                              >
                              <span class="channel-select">
                                <span>
                                  <input
                                    class="omni-input pointer-none"
                                    type="radio"
                                    value="transfer"
                                    name="paymentChannel"
                                    id="transfer_channel"
                                    />
                                  <label for="transfer_channel"></label>
                                </span>
                              </span>
                              <span class="channel-label"> Pay by Transfer </span>
                            </button>
                          < </button>
                        </li>
                        <li
                          class="nav-item"
                          role="presentation"
                          *ngIf="directDebit"
                          >
                          < <button class="nav-link" id="direct-debit-tab" data-bs-toggle="tab" data-bs-target="#direct-debit" type="button" role="tab" aria-controls="direct-debit" aria-selected="false"> --
                          <button
                            class="managedaccount__channel nav-link"
                            id="direct-debit-tab"
                            data-channel="account"
                            data-bs-toggle="tab"
                            data-bs-target="#direct-debit"
                            type="button"
                            role="tab"
                            aria-controls="direct-debit"
                            aria-selected="false"
                            >
                            <span class="channel-select">
                              <span>
                                <input
                                  class="omni-input pointer-none"
                                  type="radio"
                                  value="direct-debit"
                                  name="paymentChannel"
                                  id="direct-debit_channel"
                                  />
                                <label for="direct-debit_channel"></label>
                              </span>
                            </span>
                            <span class="channel-label">
                              Pay with Direct Debit
                            </span>
                          </button>
                        < </button> -
                      </li>
                    </ul> -->
                          <div class="tab-content" id="accountsTabContent">
                            <div
                              class="tab-pane fade show active"
                              id="transfer"
                              role="tabpanel"
                              aria-labelledby="transfer-tab"
                            >
                              <ng-container>
                                <transfer-channel
                                  [activeTab]="activePaymentTab"
                                  (onClose)="closePopup()"
                                  (onComplete)="paymentCompleted($event)"
                                >
                                </transfer-channel>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                }
                @if (hasVisitedChannel("qr")) {
                  <div
                    class="tab-pane fade zp:my-12"
                    id="qr-channel"
                    role="tabpanel"
                    aria-labelledby="qr-tab"
                    [class.zp:hidden]="!checkChannels('qr')"
                  >
                    <qr-channel></qr-channel>
                  </div>
                }
                @if (hasVisitedChannel("ussd")) {
                  <div
                    class="zp:my-12"
                    aria-labelledby="ussd-tab"
                    [class.zp:hidden]="!checkChannels('ussd')"
                  >
                    <ussd-channel
                      [activeTab]="activePaymentTab"
                      (onComplete)="paymentCompleted($event)"
                    ></ussd-channel>
                  </div>
                }
                @if (checkChannels("google_pay")) {
                  <div class="zp:my-12" aria-labelledby="google-tab">
                    <google-channel
                      [activeTab]="activePaymentTab"
                      (onComplete)="paymentCompleted($event)"
                    ></google-channel>
                  </div>
                }
                @if (checkChannels("at-ease")) {
                  <div class="zp:my-12" aria-labelledby="payattitude-tab">
                    <payattitude-channel
                      [activeTab]="activePaymentTab"
                      (onComplete)="paymentCompleted($event)"
                    ></payattitude-channel>
                  </div>
                }
                @if (checkChannels("payattitude")) {
                  <div class="zp:my-12" aria-labelledby="payattitude-tab">
                    <payattitude-channel
                      [activeTab]="activePaymentTab"
                      (onComplete)="paymentCompleted($event)"
                    ></payattitude-channel>
                  </div>
                }

                @if (checkChannels("opay")) {
                  <div class="zp:my-12" aria-labelledby="paywithopay-tab">
                    <paywithopay-channel
                      [activeTab]="activePaymentTab"
                      (onComplete)="paymentCompleted($event)"
                    ></paywithopay-channel>
                  </div>
                }
              </section>
              <footer
                class="zp:row-span-1 zp:md:row-span-1 zp:self-end zp:mb-2 zp:px-4 zp:md:px-8"
              >
                @if (!state.completed && currency !== "USD") {
                  <div
                    class="zp:md:hidden zp:mb-17 zp:flex zp:justify-center zp:items-center"
                  >
                    <button
                      class="zp:border zp:border-ZTN-300 zp:text-xs zp:rounded-2xl zp:py-2 zp:px-3 zp:bg-ZTN-50 zp:cursor-pointer"
                      (click)="changePaymentMethod()"
                    >
                      Change Payment method
                    </button>
                  </div>
                }
                <p class="zp:text-center zp:text-ZTN-500 zp:text-[10px]">
                  <a
                    href="https://zestpayment.com"
                    rel="noreferrer"
                    target="_blank"
                    class="footer__link"
                  >
                    <span
                      >Secured by
                      <span class="zp:text-ZTN-900 zp:font-semibold">{{
                        client | uppercase
                      }}</span></span
                    >
                  </a>
                </p>
              </footer>
            </main>
          </div>
        } @else {
          @if (state.completed) {
            <div
              class="omni-checkout-alert zp:min-h-[50vh] zp:flex zp:justify-center zp:items-center zp:rounded-lg"
              [@fadeAnimation]
            >
              <div class="text-center">
                <div class="custom-alert-icon mb-3">
                  <div class="success-checkmark">
                    <div class="check-icon">
                      <span class="icon-line line-tip"></span>
                      <span class="icon-line line-long"></span>
                      <div class="icon-circle"></div>
                      <div class="icon-fix"></div>
                    </div>
                  </div>
                </div>
                <div class="zp:text-center">
                  <div class="zp:font-medium zp:text-2xl zp:text-ZTN-900">
                    Successful
                  </div>
                  <div class="">
                    <small class="zp:text-ZTN-500 zp:text-base zp:font-normal">
                      Your payment has been made successfully
                    </small>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
  @if (state.error) {
    <ng-container>
      <div
        class="omni-checkout-alert zp:bg-white zp:max-w-full zp:p-3 zp:md:max-w-166.5 zp:relative zp:mx-auto zp:rounded zp:overflow-hidden zp:min-h-[50vh] zp:flex zp:justify-center zp:items-center zp:rounded-lg"
        [@fadeAnimation]
      >
        <div class="text-center">
          <div class="zp:text-center">
            <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
              <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
            </div>
            <div
              class="zp:font-medium zp:text-base zp:md:text-xl zp:text-ZTN-900"
            >
              We could not initialize this transaction
            </div>
            <div class="">
              <small
                class="zp:text-ZTN-500 zp:text-xs zp:text-sm zp:font-normal"
              >
                {{ errorMessage }}
              </small>
            </div>
            <div class="zp:mt-6 zp:flex zp:justify-center zp:items-center">
              <button
                class="zp:border zp:border-ZTN-300 zp:text-xs zp:rounded-2xl zp:py-2 zp:px-3 zp:bg-ZTN-50 zp:cursor-pointer"
                (click)="closePopup()"
              >
                Cancel Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  }
</section>
